import { ReceiptTypeEnum } from "@prostocheck/shared";

/** `CheckDocumentSubType` → the three kinds the product shows. */
export const RECEIPT_TYPE_BY_SUB_TYPE: Record<string, ReceiptTypeEnum> = {
  "0": ReceiptTypeEnum.Sale,
  "1": ReceiptTypeEnum.Return,
  "2": ReceiptTypeEnum.Service,
  "3": ReceiptTypeEnum.Service,
  "4": ReceiptTypeEnum.Service,
  // A storno reverses a registered receipt, so it moves money the way a return
  // does; the product has no separate kind for it.
  "5": ReceiptTypeEnum.Return,
};

/** An offline fiscal number is `<session>.<number>.<check digit>`. */
export const OFFLINE_FISCAL_NUMBER_PATTERN = /\./;
